import * as React from 'react';
import { SVGProps, memo } from 'react';

function VerticalDotsIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
      data-testid="verticalDotsIcon"
    >
      <path
        fill="#333"
        fillRule="evenodd"
        d="M12 5.071A1.286 1.286 0 1 1 12 2.5a1.286 1.286 0 0 1 0 2.571Zm0 7.715a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572Zm-1.285 6.428a1.286 1.286 0 1 0 2.571 0 1.286 1.286 0 0 0-2.571 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function VerticalDotsOutlineIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={6}
      height={24}
      fill="none"
      data-testid="verticalDotsOutlineIcon"
      {...props}
    >
      <path
        d="M2.5 23.1667C3.60457 23.1667 4.5 22.2712 4.5 21.1667C4.5 20.0621 3.60457 19.1667 2.5 19.1667C1.39543 19.1667 0.5 20.0621 0.5 21.1667C0.5 22.2712 1.39543 23.1667 2.5 23.1667Z"
        stroke={props?.stroke ? props.stroke : '#0D0D0D'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 13.8333C3.60457 13.8333 4.5 12.9379 4.5 11.8333C4.5 10.7288 3.60457 9.83333 2.5 9.83333C1.39543 9.83333 0.5 10.7288 0.5 11.8333C0.5 12.9379 1.39543 13.8333 2.5 13.8333Z"
        stroke={props?.stroke ? props.stroke : '#0D0D0D'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 4.5C3.60457 4.5 4.5 3.60457 4.5 2.5C4.5 1.39543 3.60457 0.5 2.5 0.5C1.39543 0.5 0.5 1.39543 0.5 2.5C0.5 3.60457 1.39543 4.5 2.5 4.5Z"
        stroke={props?.stroke ? props.stroke : '#0D0D0D'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(VerticalDotsIcon);
